/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: Residentials
// ====================================================

export interface Residentials_residentials {
  __typename: "Residential";
  id: string;
  residential: string;
}

export interface Residentials {
  residentials: Residentials_residentials[];
}

export interface ResidentialsVariables {
  administrator: string;
}
